<template>
  <b-modal
    ref="modal"
    title="Selecione a embalagem"
    centered
    size="lg"
    no-close-on-backdrop
    @shown="aoAbrir"
    @hidden="aoFechar"
  >
    <p class="mb-4">
      Escolha como <strong>{{ produto.descricao }}</strong> será vendido.
    </p>

    <b-list-group>
      <b-list-group-item
        v-for="embalagem in embalagens"
        :key="embalagem.id_produto_embalagem"
        ref="itensEmbalagem"
        button
        :active="idSelecionado === embalagem.id_produto_embalagem"
        class="d-flex align-items-center justify-content-between"
        @click="selecionar(embalagem)"
        @dblclick="confirmar"
      >
        <div>
          <strong>{{ descricaoUnidade(embalagem) }}</strong>
          <span
            v-if="embalagem.embalagem_padrao"
            class="badge badge-light ml-2"
          >
            Padrão
          </span>
          <span
            class="d-block small"
            :class="
              idSelecionado === embalagem.id_produto_embalagem
                ? 'text-white'
                : 'text-muted'
            "
          >
            Baixa {{ formatarQuantidade(embalagem.fator_conversao) }}
            {{ descricaoUnidadeBase }} do estoque
            <template v-if="embalagem.cod_barras">
              · Cód. barras: {{ embalagem.cod_barras }}
            </template>
          </span>
        </div>
        <strong class="font-size-lg">
          {{ formatarMoeda(embalagem.preco) }}
        </strong>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
      <b-button
        variant="primary"
        :disabled="!embalagemSelecionada"
        @click="confirmar"
      >
        Usar embalagem
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "EmbalagemProdutoModal",
  data() {
    return {
      produto: {},
      embalagens: [],
      idSelecionado: null,
      resolver: null,
    };
  },
  beforeDestroy() {
    this.removerAtalhosTeclado();
  },
  computed: {
    embalagemSelecionada() {
      return (
        this.embalagens.find(
          (embalagem) => embalagem.id_produto_embalagem === this.idSelecionado
        ) || null
      );
    },
    descricaoUnidadeBase() {
      const unidade = this.produto?.unidade_medida || {};
      return unidade.sigla || unidade.un || unidade.nome || "unidades";
    },
  },
  methods: {
    abrir({ produto, embalagemSelecionada = null }) {
      if (this.resolver) this.resolver(null);

      this.produto = produto || {};
      const alternativas = Array.isArray(produto?.embalagens)
        ? produto.embalagens
        : [];
      this.embalagens = [
        {
          id_produto_embalagem: "__padrao__",
          embalagem_padrao: true,
          unidade_medida: produto?.unidade_medida || null,
          preco: produto?.preco,
          fator_conversao: 1,
          cod_barras: produto?.cod_barras || null,
        },
        ...alternativas,
      ];
      const idSelecaoAtual = embalagemSelecionada?.id_produto_embalagem;
      const selecaoAtualExiste = this.embalagens.some(
        (embalagem) => embalagem.id_produto_embalagem === idSelecaoAtual
      );
      this.idSelecionado = selecaoAtualExiste
        ? idSelecaoAtual
        : this.embalagens[0]?.id_produto_embalagem ?? null;

      this.$refs.modal.show();

      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    selecionar(embalagem) {
      this.idSelecionado = embalagem.id_produto_embalagem;
    },
    aoAbrir() {
      this.removerAtalhosTeclado();
      this._atalhoTeclado = (evento) => this.tratarAtalhoTeclado(evento);
      document.addEventListener("keydown", this._atalhoTeclado);
      this.rolarParaSelecionada();
    },
    removerAtalhosTeclado() {
      if (!this._atalhoTeclado) return;
      document.removeEventListener("keydown", this._atalhoTeclado);
      this._atalhoTeclado = null;
    },
    tratarAtalhoTeclado(evento) {
      if (evento.altKey || evento.ctrlKey || evento.metaKey) return;

      if (evento.key === "ArrowDown") {
        evento.preventDefault();
        evento.stopPropagation();
        this.navegar(1);
        return;
      }

      if (evento.key === "ArrowUp") {
        evento.preventDefault();
        evento.stopPropagation();
        this.navegar(-1);
        return;
      }

      if (evento.key === "Enter") {
        evento.preventDefault();
        evento.stopPropagation();
        this.confirmar();
      }
    },
    navegar(direcao) {
      if (!this.embalagens.length) return;

      const indiceAtual = this.embalagens.findIndex(
        (embalagem) => embalagem.id_produto_embalagem === this.idSelecionado
      );
      const inicio = indiceAtual >= 0 ? indiceAtual : 0;
      const proximoIndice =
        (inicio + direcao + this.embalagens.length) % this.embalagens.length;
      this.idSelecionado = this.embalagens[proximoIndice].id_produto_embalagem;
      this.rolarParaSelecionada();
    },
    rolarParaSelecionada() {
      this.$nextTick(() => {
        const indice = this.embalagens.findIndex(
          (embalagem) => embalagem.id_produto_embalagem === this.idSelecionado
        );
        const item = this.$refs.itensEmbalagem?.[indice];
        const elemento = item?.$el || item;
        if (elemento?.scrollIntoView) {
          elemento.scrollIntoView({ block: "nearest" });
        }
      });
    },
    confirmar() {
      if (!this.embalagemSelecionada) return;
      this.finalizar({ ...this.embalagemSelecionada });
    },
    cancelar() {
      this.finalizar(null);
    },
    finalizar(resultado) {
      this.removerAtalhosTeclado();
      const resolver = this.resolver;
      this.resolver = null;
      if (resolver) resolver(resultado);
      this.$refs.modal.hide();
    },
    aoFechar() {
      this.removerAtalhosTeclado();
      if (this.resolver) {
        this.resolver(null);
        this.resolver = null;
      }
    },
    descricaoUnidade(embalagem) {
      const unidade = embalagem?.unidade_medida || {};
      if (unidade.nome && unidade.sigla) {
        return `${unidade.nome} (${unidade.sigla})`;
      }
      return unidade.nome || unidade.sigla || unidade.un || "Embalagem";
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor) || 0);
    },
    formatarQuantidade(valor) {
      return new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 4,
      }).format(Number(valor) || 0);
    },
  },
};
</script>
